export default function LacwWordmark({ className = "", compact = false }) {
  return (
    <img 
      src="/lacw-logo.png" 
      alt="Law &amp; Advocacy Centre for Women" 
      className={`h-12 object-contain ${className}`} 
    />
  );
}
